import React from 'react';
import './Hero.css';

interface HeroProps {
  onRequestQuote: () => void;
}

const Hero: React.FC<HeroProps> = ({ onRequestQuote }) => {
  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="hero section">
      <div className="hero__bg">
        <div className="hero__orb hero__orb--1"></div>
        <div className="hero__orb hero__orb--2"></div>
        <div className="hero__grid"></div>
      </div>

      <div className="container">
        <div className="hero__inner">
          <div className="hero__content">
            <div className="hero__label">
              <span className="hero__label-dot"></span>
              ICT Solutions Company
            </div>

            <h1 className="hero__title">
              Enterprise Digital Solutions
              <span className="hero__title-accent"> Built for Scale</span>
            </h1>

            <p className="hero__subtitle">
              Sky3ware Studios delivers professional web, mobile, and systems solutions designed to support growth, automation, and operational efficiency.
            </p>

            <div className="hero__actions">
              <button className="btn btn-primary btn-large" onClick={onRequestQuote}>
                Request a Quote
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <button className="btn btn-outline-white btn-large" onClick={() => scrollTo('portfolio')}>
                View Our Work
              </button>
            </div>

            <div className="hero__stats">
              <div className="hero__stat">
                <span className="hero__stat-value">50+</span>
                <span className="hero__stat-label">Projects Delivered</span>
              </div>
              <div className="hero__stat-divider"></div>
              <div className="hero__stat">
                <span className="hero__stat-value">6</span>
                <span className="hero__stat-label">Service Disciplines</span>
              </div>
              <div className="hero__stat-divider"></div>
              <div className="hero__stat">
                <span className="hero__stat-value">24–48h</span>
                <span className="hero__stat-label">Response Time</span>
              </div>
            </div>
          </div>

          <div className="hero__visual" aria-hidden="true">
            <div className="hero__dashboard">
              <div className="hero__dash-header">
                <div className="hero__dash-dots">
                  <span></span><span></span><span></span>
                </div>
                <span className="hero__dash-title">Project Dashboard</span>
              </div>
              <div className="hero__dash-body">
                <div className="hero__dash-row">
                  <div className="hero__dash-label">Web Platform</div>
                  <div className="hero__dash-bar">
                    <div className="hero__dash-fill" style={{width:'88%'}}></div>
                  </div>
                  <div className="hero__dash-pct">88%</div>
                </div>
                <div className="hero__dash-row">
                  <div className="hero__dash-label">Mobile App</div>
                  <div className="hero__dash-bar">
                    <div className="hero__dash-fill" style={{width:'72%'}}></div>
                  </div>
                  <div className="hero__dash-pct">72%</div>
                </div>
                <div className="hero__dash-row">
                  <div className="hero__dash-label">Dashboard</div>
                  <div className="hero__dash-bar">
                    <div className="hero__dash-fill" style={{width:'95%'}}></div>
                  </div>
                  <div className="hero__dash-pct">95%</div>
                </div>
                <div className="hero__dash-row">
                  <div className="hero__dash-label">IT Consulting</div>
                  <div className="hero__dash-bar">
                    <div className="hero__dash-fill hero__dash-fill--done" style={{width:'100%'}}></div>
                  </div>
                  <div className="hero__dash-pct">Done</div>
                </div>
              </div>
              <div className="hero__dash-footer">
                <div className="hero__dash-badge">
                  <span className="hero__dash-badge-dot"></span>
                  4 Active Engagements
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
